const letter_regex = /^[A-Za-z\s]+$/;
const email_regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export { letter_regex, email_regex };
